module.exports = __webpack_public_path__ + "img/DSCN0310.48bfa87f.jpg";